import React from 'react';
import { useAssetReportAPI } from '../../domain/assetReport/api/AssetReport.api';
import {
  useAppStateAssetReportListStore,
  useAppStateCurrentAssetReportStore,
  useAppStatePrevAssetReportStore,
  useAppStateYearSettlementModalDataStore,
} from '../store/AppStateStore.zustand';
import { getCurrentYear, getFirstAndLastMonthReports } from '../../domain/assetReport/util/YearSettlement.util';

const CommonTitle = () => {
  const { assetReportList } = useAppStateAssetReportListStore();
  const { currentAssetReport, setCurrentAssetReport } = useAppStateCurrentAssetReportStore();
  const { setPrevAssetReport } = useAppStatePrevAssetReportStore();
  const { setYearSettlementModalData } = useAppStateYearSettlementModalDataStore();

  const handleAssetReportSelect = (assetReportId: string) => {
    const index = assetReportList.findIndex((assetReport) => assetReport.id === assetReportId);
    if (index === -1) {
      setCurrentAssetReport(undefined);
      setPrevAssetReport(undefined);
      return;
    }
    setCurrentAssetReport(assetReportList[index]);
    if (assetReportList.length > index + 1) {
      setPrevAssetReport(assetReportList[index + 1]);
    } else {
      setPrevAssetReport(undefined);
    }
  };

  const handleYearSettlementClick = () => {
    if (!currentAssetReport) return;

    const currentYear = getCurrentYear(currentAssetReport);
    if (!currentYear) return;

    const { firstMonthReport, lastMonthReport } = getFirstAndLastMonthReports(assetReportList, currentYear);
    if (!firstMonthReport || !lastMonthReport) return;

    setYearSettlementModalData({
      isOpen: true,
      onClose: () => setYearSettlementModalData(undefined),
      firstMonthReport,
      lastMonthReport,
      year: currentYear,
    });
  };

  return (
    <div className="mb-10 flex justify-between items-center">
      <div className="pr-6 break-keep">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">자산 대시보드</h2>
        <p className="text-gray-500">효율적인 자산 관리로 더 나은 미래를 설계하세요</p>
      </div>
      {assetReportList.length > 0 && currentAssetReport && (
        <div className="flex items-center space-x-3">
          <div className="relative">
            <select
              value={currentAssetReport.id}
              onChange={(e) => handleAssetReportSelect(e.target.value)}
              className="appearance-none bg-white border border-gray-200 rounded-lg py-2.5 pl-4 pr-10 text-gray-700 shadow-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-500 cursor-pointer !rounded-button whitespace-nowrap transition-all duration-200"
            >
              {assetReportList.map((assetReport) => (
                <option value={assetReport.id}>{assetReport.yearMonth}</option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <i className="fas fa-chevron-down"></i>
            </div>
          </div>
          <button
            onClick={handleYearSettlementClick}
            className="bg-blue-600 text-white px-4 py-2.5 rounded-lg hover:bg-blue-700 transition-all duration-200 flex items-center space-x-2 !rounded-button whitespace-nowrap"
          >
            <i className="fas fa-chart-line"></i>
            <span>{getCurrentYear(currentAssetReport)}년 결산</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default CommonTitle;
